import type { IconProps } from '@openeducation/oe-rn-shared-types';
import { ColorsType, styled } from '@openeducation/oe-rn-themes';
import { useTheme } from 'react-native-paper';

import { CheckIcon } from '../../atoms';

export interface CardIconProps {
  selected?: boolean;
  hovered?: boolean;
  icon: (props: IconProps) => JSX.Element;
}

export function CardIcon({ selected, icon, hovered }: CardIconProps) {
  const { colors } = useTheme();

  return (
    <IconContainer selected={selected} hovered={hovered}>
      {selected ? <CheckIcon /> : icon({ fill: colors.primary })}
    </IconContainer>
  );
}

const IconContainer = styled.View<{ selected?: boolean; hovered?: boolean }>`
  height: 48px;
  width: 48px;
  align-items: center;
  justify-content: center;
  border-radius: 24px;
  background-color: ${({ theme: { color }, selected, hovered }) =>
    getBgColor(color, !!selected, !!hovered)};
  border: 1px solid
    ${({ theme: { color }, selected, hovered }) =>
      getBorderColor(color, !!selected, !!hovered)};
  position: absolute;
  top: -24px;
  left: 16px;
`;

function getBgColor(color: ColorsType, selected: boolean, hovered: boolean) {
  if (selected) {
    return color.primary;
  }

  if (hovered) {
    return color.white;
  }

  return color.backgroundOeBlue20;
}

function getBorderColor(
  color: ColorsType,
  selected: boolean,
  hovered: boolean
) {
  if (selected) {
    return color.transparent;
  }

  if (hovered) {
    return color.primary;
  }

  return color.backgroundOeBlue20;
}
